import { ErrorInfo } from '../components/error-info';
import { ShippingService } from '../components/shipping-service';
import { ShipmentRecord } from '../components/shipment-record';
import { OutcomeSummary } from '../components/outcome-summary';
import { useReturnDataContext } from '../return-data-provider';

export function ReturnDetailsFulfillment() {
  const { requestDetails } = useReturnDataContext();

  const returnMode = requestDetails?.mode ?? '';
  const isAdvancedReturn = returnMode === 'ADVANCED';

  return (
    <>
      <ErrorInfo />
      <ShippingService />
      <ShipmentRecord />
      {isAdvancedReturn && <OutcomeSummary />}
    </>
  );
}
